import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

//SVGs

import DownArrow from "assets/images/svg-icons/chevron-down.svg";
import FolderIcon from "assets/images/svg-icons/foldericon.svg";
import ImageIcon from "assets/images/svg-icons/imageicon.svg";
// import PDFIcon from "assets/images/svg-icons/pdficon.svg";

const TypeMenu = ({ sortModal, setSortModal }) => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const menuItems = [
    // { label: "all", value: "all", icon: ImageIcon },
    { label: "common.folderCap", value: "folder", icon: FolderIcon },
    { label: "common.file", value: "file", icon: ImageIcon },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubmit = (value) => {
    setSortModal({ ...sortModal, type: value });
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        endIcon={
          <MuiBox sx={{ height: "20px", width: "20px", display: "flex" }}>
            <img src={DownArrow} alt="" className="img-full" />
          </MuiBox>
        }
        sx={{
          p: "8px 16px",
          color: "text.darkBlack",
          backgroundColor: "background.blue200",
          borderRadius: "8px",
          width: "100%",
          maxWidth: "110px",
          flexShrink: 0,
          justifyContent: "space-between",
        }}
        onClick={handleClick}
      >
        {t("common.type")}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          disablePadding: true,
        }}
        slotProps={{
          paper: {
            sx: {
              mt: "8px",
              p: "8px",
              boxShadow: "0px 6px 24px 0px #0000000D",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "background.gray400",
            },
          },
        }}
      >
        {menuItems?.map((item) => (
          <MenuItem
            key={item?.value}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              my: "1px",
              borderRadius: "8px",
              backgroundColor:
                item?.value === sortModal?.type ? "background.blue200" : "none",
            }}
            onClick={() => handleSubmit(item?.value)}
          >
            <MuiBox sx={{ height: "25px", width: "25px" }}>
              <img src={item?.icon} alt="" className="img-contain" />
            </MuiBox>
            <MuiTypography fontWeight="500" variant="14" color="text.darkBlack">
              {t(item?.label)}
            </MuiTypography>
          </MenuItem>
        ))}
        {/* <MenuItem
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            borderRadius: "8px",
          }}
          onClick={handleClose}
        >
          <MuiBox sx={{ height: "25px", width: "25px" }}>
            <img src={ImageIcon} alt="" className="img-contain" />
          </MuiBox>
          <MuiTypography fontWeight="500" variant="14" color="text.darkBlack">
            {t("common.file")}
          </MuiTypography>
        </MenuItem> */}
        {/* <MenuItem
          sx={{ display: "flex", alignItems: "center", gap: "8px" }}
          onClick={handleClose}
        >
          <MuiBox sx={{ height: "25px", width: "25px" }}>
            <img src={PDFIcon} alt="" className="img-contain" />
          </MuiBox>
          <MuiTypography fontWeight="500" variant="14" color="text.darkBlack">
            PDF
          </MuiTypography>
        </MenuItem> */}
      </Menu>
    </>
  );
};

export default TypeMenu;
